import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import ClientUrlForm from "components/Admin/ClientUrls/ClientUrlForm";
import actions from "actions";
import constants from "constants";
import validator from "services/validator";
import inputFormatter from "services/userInputFormatter";

const { CREATE_CLIENT_URL_SAGA } = constants;

const {
  createClientUrlSaga,
  setTempClientUrl,
  cleanErrors,
} = actions;

class NewClientUrl extends Component {
  static propTypes = {
    createUserSponsor: PropTypes.func,
    cleanErrors: PropTypes.func,
    dispatch: PropTypes.func,
    errors: PropTypes.obj,
    errorsFrontend: PropTypes.obj,
  };

  constructor(props) {
    super(props);

    let tempClientUrl = {};

    if (
      props.location.state &&
      props.location.state.from === "addWebinars"
    ) {
      tempClientUrl = {
        ...props.temp,
        ...{
          webinar_ids: (props.temp && props.temp.webinar_ids) || [],
        },
      };
    }
    this.state = {
      client_url: {
        name: "",
        slug: "",
        webinar_ids: [],
        ...tempClientUrl,
      },
    };
  }

  componentWillMount() {
    this.props.cleanErrors();
  }

  onFieldChange = (e) => {
    const input = inputFormatter.formatField(e.target.name, e.target.value);
    const clientUrlData = {
      ...this.state.client_url,
      ...{
        [e.target.name]: input,
      },
    };

    this.setState({ client_url: clientUrlData });
  };

  onSubmit = () => {
    this.props.create(this.state.client_url);
  };

  goToAddWebinarsPage = () => {
    this.props.setTemp(this.state.client_url);
    this.props.router.push("/client-url/new/add-webinars");
  };

  render() {
    const { errors, errorsFrontend, role } = this.props;

    return (
      <main className="site--width clearfix-c">
        <ClientUrlForm
          onFieldChange={this.onFieldChange}
          client_url={this.state.client_url}
          onSubmit={this.onSubmit}
          errors={validator.formatErrors(errors, errorsFrontend)}
          goToAddWebinarsPage={this.goToAddWebinarsPage}
          role={role}
        />
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    role: state.users.user.role,
    temp: state.clientUrls.admin.temp,
    errors: state.errors[CREATE_CLIENT_URL_SAGA],
    errorsFrontend: state.errors[`${CREATE_CLIENT_URL_SAGA}_FRONTEND`],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    create: (clientUrl) => dispatch(createClientUrlSaga(clientUrl)),
    setTemp: (clientUrl) => dispatch(setTempClientUrl(clientUrl)),
    cleanErrors: () => dispatch(cleanErrors(CREATE_CLIENT_URL_SAGA)),
    dispatch: dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewClientUrl);



// WEBPACK FOOTER //
// ./src/containers/Admin/ClientUrls/NewClientUrl.jsx